<script setup>
const props = defineProps({
  article: {
    type: Object,
    required: true,
  },
})
const config = useRuntimeConfig()
// You can use useRuntimeConfig() to access your public CDN URL
</script>

<template>
  <div class="flex flex-col h-full rounded-lg shadow overflow-hidden">
    <!-- Image + link -->
    <div class="flex-shrink-0">
      <ULink :to="$localePath({ name: 'ArticlePage', params: { id: article.id, slug: article.slug } })">
        <img
          class="h-48 w-full object-cover"
          :src="`${config.public.backendCdnUrl}${article.thumbnailUrl}`"
          alt=""
          loading="lazy"
        >
      </ULink>
    </div>

    <!-- Content area -->
    <div class="flex-1 min-h-0 bg-white p-4 flex flex-col">
      <div class="flex flex-col justify-start overflow-hidden shrink-0">
        <!-- Blog title -->
        <p class="text-sm font-medium text-indigo-600">
          <span
            class="text-tomate-400 font-semibold tracking-wide uppercase"
          >
            {{ article.blog.title }}
          </span>
        </p>

        <!-- Article title & preview -->
        <ULink class="text-lg/6 font-semibold text-poivre-800" :to="$localePath({ name: 'ArticlePage', params: { id: article.id, slug: article.slug } })">
          {{ article.title }}
        </ULink>
        <ClientOnly>
          <p
            class="mt-3 text-base text-poivre-500 line-clamp-4"
            v-html="article.preview"
          />
          <template #fallback>
            <p class="mt-3 text-base text-poivre-500 line-clamp-4">
              {{ article.preview?.replace(/<[^>]*>/g, '') || '' }}
            </p>
          </template>
        </ClientOnly>
      </div>

      <!-- Spacer that grows -->
      <div class="flex-1 min-h-0" />

      <!-- Author -->
      <div class="mt-3 flex items-center shrink-0">
        <div class="flex-shrink-0">
          <img
            class="h-10 w-10 rounded-full"
            :src="`${config.public.backendCdnUrl}${article.authorUrl}`"
            alt=""
            loading="lazy"
          >
        </div>
        <div class="ml-3">
          <p class="text-sm font-medium text-poivre-800">
            {{ article.authorName }}
          </p>
          <p class="text-sm text-poivre-500">
            {{ article.reading_time }} min à lire
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
